// imageHelper.ts

import { centralizedSasToken } from "~/Utils";

const DEFAULT_SAS_TOKEN =
  "sp=racwdl&st=2026-01-11T06:34:11Z&se=2027-01-12T02:00:00Z&spr=https&sv=2024-11-04&sr=c&sig=nzjHZlp%2B2DUPtpQhxOM7geRd41trOEQdM6KH89yV7eo%3D";

export const appendSasToken = (url?: string): string | undefined => {
  if (!url) return url;

  if (url.includes("sig=")) return url;

  return url.includes("?")
    ? `${url}&${centralizedSasToken || DEFAULT_SAS_TOKEN}`
    : `${url}?${centralizedSasToken || DEFAULT_SAS_TOKEN}`;
};

// export const appendSasTokenRichText = (url: string) => {
//   if (!url) return url;

//   if (url.includes("sig=")) {
//     return url;
//   }

//   const [baseUrl] = url.split("?");

//   return `${baseUrl}?${centralizedSasToken}`;
// };

export const appendSasTokenRichText = (url: string) => {
  if (!url) return url;

  if (url.includes("sp=") || url.includes("sig=") || url.includes("sv=")) {
    return url;
  }

  const [baseUrl] = url.split("?");

  return `${baseUrl}?${centralizedSasToken || DEFAULT_SAS_TOKEN}`;
};

// add SAS when rendering in description
// export const addSasToImages = (html: string): string => {
//   if (!html) return html;

//   return html.replace(/<img([^>]+)src="([^"]+)"([^>]*)>/g, (match, before, src, after) => {
//     if (src.includes("sig=")) return match;

//     const finalSrc = src.includes("?") ? `${src}&${centralizedSasToken}` : `${src}?${centralizedSasToken}`;

//     return `<img${before}src="${finalSrc}"${after}>`;
//   });
// };

export const addSasToImages = (html: string): string => {
  if (!html) return html;

  return html.replace(/<img([^>]+)src="([^"]+)"([^>]*)>/g, (match, before, src, after) => {
    if (src.includes("sp=") || src.includes("sig=") || src.includes("sv=")) {
      return match;
    }

    const finalSrc = src.includes("?")
      ? `${src}&${centralizedSasToken || DEFAULT_SAS_TOKEN}`
      : `${src}?${centralizedSasToken || DEFAULT_SAS_TOKEN}`;

    return `<img${before}src="${finalSrc}"${after}>`;
  });
};

export const removeSasFromDescription = (html: string): string => {
  if (!html) return html;

  return html.replace(/(<img[^>]+src=["'])([^"']+?)([?&]sp=[^"']+)(["'][^>]*>)/gi, (_match, start, url, _sas, end) => {
    const cleanUrl = url.split("?sp=")[0];
    return `${start}${cleanUrl}${end}`;
  });
};
